import Vue from 'vue';
import {pageScroll} from '../../../assets/utils';
import ConfirmTpl from './ConfirmTpl';

const ConfirmConstructor = Vue.extend(ConfirmTpl);

const instance = new ConfirmConstructor({
  el: document.createElement('div')
});

ConfirmConstructor.prototype.closeConfirm = function closeConfirm(stay, callback) {
  if (typeof callback === 'function') {
    callback();
  }

  if (stay) {
    return;
  }

  pageScroll.unlock();

  const el = instance.$el;
  if (el.parentNode) {
    el.parentNode.removeChild(el);
  }
};

const Confirm = (options = {}) => {
  instance.mes = options.mes || '';
  instance.title = options.title || '';
  instance.opts = options.opts;

  document.body.appendChild(instance.$el);

  pageScroll.lock();
};

export default Confirm;
export {Confirm};



// WEBPACK FOOTER //
// ./src/components/Dialog/confirm/index.js